import React, { useState, useEffect } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../data/mock';
import { trackWhatsApp, trackNav } from '../lib/analytics';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    trackWhatsApp('header');
    const message = 'Olá! Vim pelo site da ABR Barbearia e gostaria de agendar um horário.';
    const url = `https://wa.me/${businessInfo.phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const scrollToSection = (id) => {
    trackNav(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { name: 'Início', id: 'inicio' },
    { name: 'Serviços', id: 'servicos' },
    { name: 'Equipe', id: 'equipe' },
    { name: 'Sobre', id: 'sobre' },
    { name: 'Instagram', id: 'instagram' },
    { name: 'Contato', id: 'localizacao' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/90 backdrop-blur-md shadow-xl border-b border-[#D4AF37]/20' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button onClick={() => scrollToSection('inicio')} className="flex items-center hover:opacity-80 transition-opacity">
              <img 
                src="https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/hz6psjvj_4D311E0C-B149-4A05-827A-5AEAC546E82D.png" 
                alt="ABR Barbearia Logo" 
                className="h-16 w-auto object-contain"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-[#D4AF37] transition-colors font-medium"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button 
              onClick={handleWhatsApp}
              className="bg-[#D4AF37] hover:bg-[#B8941F] text-black font-semibold rounded-sm transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              Agendar Agora
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white hover:text-[#D4AF37] transition-colors"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-zinc-800">
          <nav className="container mx-auto px-4 py-6 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left text-gray-300 hover:text-[#D4AF37] transition-colors font-medium py-2"
              >
                {item.name}
              </button>
            ))}
            <Button 
              onClick={handleWhatsApp}
              className="w-full bg-[#D4AF37] hover:bg-[#B8941F] text-black font-semibold rounded-sm"
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              Agendar Agora
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;